import { jsx as e, jsxs as n } from "@emotion/react/jsx-runtime";
import { Illustration as S, IllustrationVariousEnum as _, IllustrationCategoryEnum as b } from "@partoohub/iconography";
import { Text as E, Skeleton as i, Button as I } from "@partoohub/ui";
import { ContentLayout as a, StyledBusinessCountContainer as m, StyledBusinessCount as v, StyledInfiniteScroller as c } from "./Content.styled.js";
import { useBusinessModalContext as N } from "../../../BusinessModalContext.js";
import { useBusinesses as T } from "../../../hooks/useBusinesses.js";
import { useCountData as w } from "../../../hooks/useCountData.js";
import { useIsLoadingBusinessContent as P } from "../../../hooks/useIsLoadingBusinessContent.js";
import { EmptyState as R } from "../../../../EmptyState/index.js";
import { SIZES_EMPTY_STATE as k } from "../../../../EmptyState/EmptyState.types.js";
import { BusinessCard as L } from "./BusinessCard/BusinessCard.js";
const M = ({
  numberOfElements: t = 6
}) => /* @__PURE__ */ n(a, { gap: "0px", children: [
  /* @__PURE__ */ e(m, { children: /* @__PURE__ */ e(i, { variant: "line", width: 100 }) }),
  /* @__PURE__ */ e(c, { enabled: !1, fetchNextPage: () => {
  }, children: /* @__PURE__ */ e(i, { variant: "businessCards", showContainer: !1, row: t }) })
] }), $ = ({
  size: t,
  title: s,
  description: r,
  onReset: o
}) => /* @__PURE__ */ e(a, { justifyContent: "center", alignItems: "center", hasBusinesses: !1, children: /* @__PURE__ */ e(R, { title: s, description: r, size: "medium", image: /* @__PURE__ */ e(S, { dataTrackId: "placeholder__illustration__business_modal__no_result", width: `${t}px`, height: `${t}px`, illustration: {
  type: b.Various,
  name: _.StatusNoResult
} }), children: /* @__PURE__ */ e(I, { dataTrackId: "Business_modal__button_reset", appearance: "outlined", variant: "secondary", onClick: o, children: "Reset" }) }) }), G = () => {
  const {
    translations: t,
    error: s,
    resetState: r
  } = N(), o = P(), {
    totalBusinessesCount: p
  } = w(), {
    query: h,
    businesses: l
  } = T(), {
    fetchNextPage: f,
    hasNextPage: g,
    isFetchingNextPage: u
  } = h, C = s?.reason, x = s?.reason ? t?.error?.[s.reason] ?? "" : "", y = k.medium.imageHeight;
  if (o) return /* @__PURE__ */ e(M, { numberOfElements: 4 });
  if (l.length === 0)
    return /* @__PURE__ */ e($, { size: y, title: t.emptyState.title, description: t.emptyState.description, onReset: r });
  const B = !!g && !u;
  return /* @__PURE__ */ n(a, { gap: "0px", children: [
    /* @__PURE__ */ n(m, { gap: "4px", children: [
      /* @__PURE__ */ e(v, { variant: "bodyMBold", children: `${p} ${t.fetchedBusinessCount}` }),
      C && /* @__PURE__ */ e(E, { variant: "bodySRegular", color: "danger", children: x })
    ] }),
    /* @__PURE__ */ n(c, { enabled: B, fetchNextPage: f, children: [
      l.map((d) => /* @__PURE__ */ e(L, { business: d }, d.id)),
      u && /* @__PURE__ */ e(i, { variant: "businessCards", showContainer: !1 })
    ] })
  ] });
};
export {
  G as Content
};
